// src/pages/admin/AddFeature.jsx
import React, { useState } from "react";
import { ref, push } from "firebase/database";
import { dimaniwasRtdb } from "../../firebase/config";
import styles from "./addproducts.module.css";

const AddFeature = () => {
    const [sidebarOpen, setSidebarOpen] = useState(false);
    const [title, setTitle] = useState("");
    const [imageUrl, setImageUrl] = useState("");

    // Cloudinary image upload
    const handleUpload = () => {
        window.cloudinary.openUploadWidget(
            {
                cloudName: "dev-binudstorage",
                uploadPreset: "mrittika_unsigned",
                sources: ["local"],
                multiple: false
            },
            (error, result) => {
                if (!error && result.event === "success") {
                    console.log("Image uploaded:", result.info.secure_url);
                    setImageUrl(result.info.secure_url);
                } else if (error) {
                    console.error("Cloudinary upload error:", error);
                }
            }
        );
    };

    // Save feature data to Firebase
    const handleSave = () => {
        if (!title || !imageUrl) {
            alert("Please provide a title and upload an image");
            return;
        }

        const featureData = {
            title,
            image: imageUrl,
            createdAt: Date.now()
        };

        const featuresRef = ref(dimaniwasRtdb, "features"); // Firebase path for features
        push(featuresRef, featureData)
            .then((snapshot) => {
                console.log("Feature saved with key:", snapshot.key);
                alert("Feature added successfully!");
                setTitle("");
                setImageUrl("");
            })
            .catch((error) => {
                console.error("Error saving feature:", error);
                alert("Failed to save feature.");
            });
    };

    return (
        <div className={`d-flex flex-column flex-md-row ${styles.container}`}>
            {/* Mobile menu toggle */}
            <button className="btn btn-dark d-md-none m-2" onClick={() => setSidebarOpen(!sidebarOpen)}>
                ☰ Menu
            </button>

            {/* Sidebar */}
            <div className={`bg-dark text-white p-4 ${styles.sidebar} ${sidebarOpen ? "d-block" : "d-none"} d-md-block`}>
                <h2 className={styles.logo}>Admin</h2>
                <ul className="nav flex-column admin_dashboard">
                    <li><a href="/admin/dashboard" className="nav-link text-white">Dashboard</a></li>
                    <li><a href="/admin/add-tent" className="nav-link text-white">Add Tent</a></li>
                    <li><a href="/admin/all-tents" className="nav-link text-white">Manage Tents</a></li>
                    <li><a href="/admin/add-feature" className="nav-link text-warning">Add Feature</a></li>
                    <li><a href="/admin/all-features" className="nav-link text-white">Manage Features</a></li>
                </ul>
            </div>

            {/* Main Content */}
            <div className={`p-4 w-100 ${styles.main}`}>
                <h2 className={styles.addProduct_title}>Add Feature</h2>

                <div className={styles.form}>
                    <div className={styles.formGroup}>
                        <label>Feature Name / Title</label>
                        <input type="text" value={title} onChange={(e) => setTitle(e.target.value)} className={styles.input} />
                    </div>

                    <div className={styles.imageUploadBox}>
                        <label>Upload Image</label>
                        <button onClick={handleUpload} className={styles.uploadButton}>Upload Image</button>
                        {imageUrl && <div className={styles.imagePreviewWrapper}><img src={imageUrl} alt="Preview" className={styles.imagePreview} /></div>}
                    </div>

                    <button onClick={handleSave} className={styles.saveButton}>Save Feature</button>
                </div>
            </div>
        </div>
    );
};

export default AddFeature;
